// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getSupportedTechnics = contextConfiguration => axios.get(
	'/technieken?fields=*',
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getSupportedTechnics;
